<template lang="html">
  <v-container fluid>

    <StakeVisualizer />

  </v-container>

</template>

<script>

  import StakeVisualizer from "@/components/StakeVisualizer.vue";

  export default {
    name: "Account",
    components: {
      StakeVisualizer
    },
    created() {
    },
    data() {
      return {
      }
    },
  }
</script>

<style lang="css" scoped>
</style>
